import React                                         from 'react'
import { IndexRoute, Router, Route, browserHistory } from 'react-router'
import App                                           from './containers/AppContainer';
import Places                                        from './pages/Places';
import Place                                         from './pages/Place';
import PlaceMap                                      from './pages/PlaceMap';
import Page                                          from './pages/Page';
import { Provider }                                  from 'react-redux';
import PropTypes                                     from 'prop-types';


const Root = ({ store }) => (
    <Provider store={ store }>
        <Router history={browserHistory} onUpdate={() => { window.scrollTo(0, 0);} }>
            <Route path="/" component={ App }>
                <Route path="place/:id" component={ Place } />
                <Route path="place-map/:id" component={ PlaceMap } />
                <Route path="about" component={ Page } label="about" />
                <IndexRoute component={ Places } />
            </Route>
        </Router>
    </Provider>
);

Root.propTypes = {
    store: PropTypes.object.isRequired
};

export default Root;


// WEBPACK FOOTER //
// ./src/Root.js